import type { PlaygroundSource } from '@/types/studio';

export const SOURCE_LIMIT = 50_000;
export const PLAYGROUND_STARTER: PlaygroundSource = {
  html: `<main class="studio-page">
  <nav><strong>FORMA / 001</strong><span>A place for good ideas</span></nav>
  <section class="hero">
    <div>
      <p class="eyebrow">YOUR NEXT CHAPTER</p>
      <h1>Make something<br><em>worth keeping.</em></h1>
      <p class="intro">A small idea can change the way we see everything. Give yours a little room to grow.</p>
      <button>Start exploring <span aria-hidden="true">↗</span></button>
    </div>
    <div class="art" aria-label="Abstract color composition"><i></i><i></i><i></i></div>
  </section>
  <section class="notes">
    <article><small>01 / DISCOVER</small><h2>Follow your curiosity.</h2><p>The best direction starts with something unexpected.</p></article>
    <article><small>02 / CREATE</small><h2>Find your own rhythm.</h2><p>Keep what feels right. Make the rest your own.</p></article>
    <article><small>03 / SHARE</small><h2>Put it into the world.</h2><p>A good idea gets better when it has somewhere to go.</p></article>
  </section>
  <footer>Made with a little curiosity.<span>Color Studio ↗</span></footer>
</main>`,
  css: `.studio-page { max-width: 1100px; margin: auto; padding: calc(var(--space-unit) * 8); }
nav, footer { display: flex; justify-content: space-between; gap: calc(var(--space-unit) * 4); align-items: center; font-size: .75em; }
nav { padding-bottom: calc(var(--space-unit) * 6); border-bottom: 1px solid var(--color-border); }
nav strong { letter-spacing: -.04em; font-size: 1.2em; }
.hero { display: grid; grid-template-columns: 1.3fr 1fr; gap: calc(var(--space-unit) * 10); align-items: center; padding: calc(var(--space-unit) * 17.5) 0; }
.eyebrow, small { font-size: .65em; letter-spacing: .14em; font-weight: 600; }
h1 { font-size: clamp(2.4em, 5.5vw, 4.5em); line-height: 1; letter-spacing: -.065em; margin: calc(var(--space-unit) * 6) 0; font-weight: 600; }
h1 em { color: var(--color-primary); font-weight: 400; }
.intro { max-width: 34ch; color: var(--color-muted); line-height: 1.7; font-size: .85em; }
button { margin-top: calc(var(--space-unit) * 5.5); background: var(--color-primary); color: var(--color-on-primary); border: 0; border-radius: var(--radius); padding: calc(var(--space-unit) * 3.5) calc(var(--space-unit) * 5); font: inherit; font-size: .8em; cursor: pointer; }
button span { margin-left: calc(var(--space-unit) * 7); }
button:focus-visible { outline: 2px solid var(--color-text); outline-offset: 3px; }
.art { aspect-ratio: 1; position: relative; overflow: hidden; border-radius: var(--radius); background: var(--color-secondary); }
.art i { position: absolute; width: 65%; height: 65%; border-radius: 50%; background: var(--color-primary); left: -12%; top: -12%; }
.art i:nth-child(2) { background: var(--color-accent); left: 38%; top: 38%; }
.art i:nth-child(3) { background: var(--color-surface); width: 32%; height: 32%; left: 34%; top: 34%; }
.notes { display: grid; grid-template-columns: repeat(3, 1fr); gap: calc(var(--space-unit) * 5); }
article { padding: calc(var(--space-unit) * 6); border: 1px solid var(--color-border); border-radius: var(--radius); background: var(--color-surface); }
h2 { font-size: 1.15em; letter-spacing: -.035em; line-height: 1.2; }
article p { font-size: .75em; line-height: 1.7; color: var(--color-muted); }
footer { padding-top: calc(var(--space-unit) * 9); color: var(--color-muted); }
@media (max-width: 640px) {
  .studio-page { padding: calc(var(--space-unit) * 6); }
  .hero { grid-template-columns: 1fr; gap: calc(var(--space-unit) * 7); padding: calc(var(--space-unit) * 9) 0; }
  .art { max-height: 260px; aspect-ratio: 1.5; }
  .notes { grid-template-columns: 1fr; }
  nav span { display: none; }
}`,
};
